import {
  jb_pin_icon_css_default
} from "./chunk.IHKEALAO.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-pin-icon/jb-pin-icon.ts
var JbPinIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="18"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.7002 7.05769C2.7002 3.71748 5.51979 1 8.98551 1C12.4512 1 15.2708 3.71748 15.2708 7.05769C15.2708 8.15276 14.9643 9.22594 14.3843 10.1613L9.52214 16.7546C9.42831 16.9056 9.25959 16.9986 9.07277 17C8.89169 17 8.72331 16.9098 8.62774 16.7614L3.63842 10.2431C3.02455 9.2876 2.7002 8.18624 2.7002 7.05769ZM9.06491 15.5255L13.4854 9.64291C13.9681 8.8645 14.2268 7.97042 14.2268 7.05769C14.2268 4.27418 11.8737 2.00288 8.98558 2.00288C6.09747 2.00288 3.74083 4.27418 3.74083 7.05769C3.74083 7.99832 4.01787 8.91586 4.52883 9.71116L9.06491 15.5255ZM5.84268 7.05769C5.84268 5.38759 7.25248 4.02885 8.98534 4.02885C10.7182 4.02885 12.128 5.38759 12.128 7.05769C12.128 8.69889 10.7628 10.0865 8.98534 10.0865C7.22954 10.0865 5.84268 8.71713 5.84268 7.05769ZM6.88332 7.05769C6.88332 8.17389 7.82412 9.08365 8.98541 9.08365C10.1651 9.08365 11.084 8.1576 11.084 7.05769C11.084 5.94429 10.1406 5.03173 8.98541 5.03173C7.83017 5.03173 6.88332 5.94429 6.88332 7.05769Z"
          fill="#141E55"
        />
      </svg>
    `;
  }
};
JbPinIcon.styles = [reset_css_default, jb_pin_icon_css_default];
JbPinIcon = __decorateClass([
  customElement("jb-pin-icon")
], JbPinIcon);

export {
  JbPinIcon
};
